interface ToolInvocationIndicatorProps {
  toolName: string
}

export function ToolInvocationIndicator({
  toolName,
}: ToolInvocationIndicatorProps) {
  const label =
    toolName === "query_cube_data"
      ? "Querying data..."
      : `Running ${toolName}...`

  return (
    <div className="flex items-center gap-2 text-sm opacity-70 py-1">
      <span className="loading loading-dots loading-xs" />
      <span>{label}</span>
    </div>
  )
}
